// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-text-field
    :label="label"
    :disabled="disabled"
    :value="getValue()"
    @input="(val) => changeValue(val)"
    hide-details
  ></v-text-field>
</template>

<script>
// import moment from 'moment'

export default {
  props: {
    // disable inputs to this selector
    disabled: Boolean,
    // label - text input label
    label: String,
    // unit - which time unit to display the duration as
    unit: String,
    // v-model input
    value: null
  },

  data () {
    return {
      duration: this.value
    }
  },

  watch: {
    duration () {
      this.$emit('input', this.duration)
    },

    value () {
      this.duration = this.value
    }
  },

  computed: {
    multiplier: function () {
      const SECONDS = 1000000000
      if (this.$props.unit === 'seconds') {
        return SECONDS
      } else if (this.$props.unit === 'hours') {
        return SECONDS * 60 * 60
      } else if (this.$props.unit === 'days') {
        return SECONDS * 60 * 60 * 24
      } else if (this.$props.unit === 'milliseconds') {
        return SECONDS / 1000
      }
      return SECONDS * 60 // minutes
    }
  },

  methods: {
    getValue: function () {
      if (!this.duration) {
        this.duration = 0
      }
      return this.duration / this.multiplier
    },

    changeValue: function (val) {
      this.duration = val * this.multiplier
    }

  }
}
</script>



// WEBPACK FOOTER //
// DurationView.vue?425e227a